import { MATRIX_DATA } from "../components/Matrix/data/matrix-data"



export const getStageInfo = (id: string) => {
    if (STAGES.hasOwnProperty(id)){
        let {stage_name, stage_desc} = STAGES[id]
        return {
            stageName: stage_name,
            stageDesc: stage_desc
        }
    }

    else {
        return {
            stageName: `{{name-${id}}}`,
            stageDesc: `{{desc-${id}}}`
        }
    }
}


export const getStagesForOrg = (orgID: string) => {
    let stagesID: string[] = []
    let matrixStages = MATRIX_DATA[0] as string[];
    let matrixData = MATRIX_DATA.slice(1)

    matrixData.map(item => {
        let org_id = item[0]
        if (orgID === org_id){
            for (let i = 0; i < item.length; i++){
                if (item[i] === 1){
                    stagesID.push(matrixStages[i])
                }
            }
        }
        return null
    })
    return stagesID
}


// export const MATRIX_DATA: (string|number)[][] = [
//     ["",'stage_1','stage_2','stage_3','stage_4','stage_5','stage_6','stage_7','stage_8'],
//     ["org_6",0,1,0,0,0,0,0,0],
//     ["org_7",1,1,0,1,0,0,0,0],
//     ["org_28",0,0,1,1,0,0,0,0],
//     ["org_8",0,0,1,1,0,0,0,0],
//     ["org_10",0,0,0,1,0,0,0,0],
//     ["org_9",0,0,0,0,0,1,0,0],
//     ["org_33",0,0,0,0,1,0,0,0],
//     ["org_34",0,0,0,0,1,0,0,0],
//     ["org_27",0,0,0,0,1,0,0,0],
//     ["org_12",0,0,0,0,0,0,1,0],
//     ["org_13",0,0,0,0,0,0,1,0],
//     ["org_14",0,0,0,0,0,0,1,0],
//     ["org_15",0,0,0,0,0,0,1,0],
//     ["org_16",0,0,0,0,0,0,1,0],
//     ["org_17",0,0,0,0,0,0,1,0],
//     ["org_18",0,0,0,0,0,0,1,0],
//     ["org_20",0,0,0,0,0,0,1,1],
//     ["org_22",0,0,0,0,0,0,0,1]
//   ]





export const STAGES: {
    [id: string]: {
        stage_name: string,
        stage_desc: string
    }
} = {
    "stage_2": {
       "stage_name": "Встановлення факту смерті",
       "stage_desc": "На цьому етапі відбувається первинне встановлення факту та обставин смерті. У необхідних ситуаціях повідомляється Національна поліція, виписується «Висновок про ненасильницьку смерть». Протягом всього часу надання медичної допомоги пацієнтам — на первинному чи на вторинному рівні, амбулаторно чи в стаціонарі, ведеться багато різної медичної документації. Медична документація може використовуватися для встановлення причини смерті, а також використовується для формування різноманітної медичної статистики."
    },
    "stage_3": {
       "stage_name": "Дослідження тіла померлого",
       "stage_desc": "Окремий етап дослідження трупа (патанатомічне дослідження, судово-медична експертиза), що відбувається у встановлених нормативно-правовими актами випадках."
    },
    "stage_4": {
       "stage_name": "Документування смерті",
       "stage_desc": "На основі попередньої медичної документації, огляду трупа, паталогоанатомічного дослідження або ж судово-медичної експертизи, відбувається основне первинне документування смерті — виписка лікарського свідоцтва про смерть, фельдшерської довідки про смерті, лікарського свідоцтва про перинатальну смерть. Також смерть може документуватися у вигляді рішення суду."
    },
    "stage_5": {
       "stage_name": "Проміжна реєстрація",
       "stage_desc": "Органи місцевого самоврядування (ОМС) та центри надання адміністративних послуг (ЦНАПи) можуть виконувати \\\"проміжну\\\" функцію реєстрації смерті, приймаючи від заявників лікарські свідоцтва про смерть та судові рішення, та передаючи інформацію для внесення даних до ДРАЦС до органів РАЦС. Опціональний етап, заявник може напряму звертатимя в РАЦС."
    },
    "stage_6": {
       "stage_name": "Державна реєстрація",
       "stage_desc": "Державна реєстрація смерті відбувається на підставі лікарського свідоцтва про смерті та інших документів, що утворюються на попередньому етапі. Вноситься запис в Єдиний реєстр актів цивільного стану та формується актовий запис про смерть."
    },
    "stage_7": {
       "stage_name": "Обмін даними",
       "stage_desc": "Державний реєстр актів цивільного стану обмінюється даними про померлих з іншими організаціями та реєстрами."
    },
    "stage_8": {
       "stage_name": "Збір статистики",
       "stage_desc": "Узагальнення даних про смерть, представлення стиснених даних у різних вимірах. Державна статистика формується на основі переданих управліннями юстиції до управлінь статистики в регіонах других примірників актових записів про смерть, а також лікарських свідоцтв про смерть та інших документів. Медична статистика про померлих формується на підставі медичної документації, і є певною мірою паралельним (до лінії Мінюст-Держстат) процесом обробки та узагальнення даних."
    }
 }